export default __webpack_public_path__ + "img/466f8694.png";